import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const BillingCodePage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'description', label: 'Description' },
    { key: 'category', label: 'Category' },
    { key: 'rate', label: 'Rate' },
    { key: 'revenueCode', label: 'Revenue Code' },
    { key: 'active', label: 'Active' },
  ];

  const initialData = [
    { id: '1', code: 'G0151', description: 'Physical Therapy Evaluation', category: 'Physical Therapy', rate: '$150.00', revenueCode: '0424', active: 'Yes' },
    { id: '2', code: 'G0152', description: 'Occupational Therapy Evaluation', category: 'Occupational Therapy', rate: '$145.00', revenueCode: '0434', active: 'Yes' },
    { id: '3', code: 'G0153', description: 'Speech Therapy Evaluation', category: 'Speech Therapy', rate: '$140.00', revenueCode: '0444', active: 'Yes' },
    { id: '4', code: 'G0154', description: 'Skilled Nursing Visit', category: 'Skilled Nursing', rate: '$175.00', revenueCode: '0551', active: 'Yes' },
    { id: '5', code: 'G0156', description: 'Home Health Aide Visit', category: 'Home Health Aide', rate: '$55.00', revenueCode: '0571', active: 'Yes' },
    { id: '6', code: 'G0155', description: 'Medical Social Worker Visit', category: 'Medical Social Work', rate: '$130.00', revenueCode: '0561', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Billing Code"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Code"
    />
  );
};

export default BillingCodePage;
